import Lenis from "lenis";
import {
  setDefineParams,
  defineParams,
} from "@/plugins/functions/defineParams";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Scrollbar from "smooth-scrollbar";

import { testWebp } from "./functions/testImageSupport";

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.provide("scrollbar", Scrollbar);

  if (import.meta.client) {
    setDefineParams();
    // if (!defineParams.mobileDevice) {
    // const lenis = new Lenis({
    //   lerp: 0.1, // default 0.1
    //   prevent: (node) => {
    //     return node.closest(".cky-preference-body-wrapper");
    //   },
    // });
    // lenis.on("scroll", () => ScrollTrigger.update());
    // gsap.ticker.add((time) => lenis.raf(time * 1000));
    // gsap.ticker.lagSmoothing(0);
    // }
    // webp support
    const webpSupport = await testWebp();
    document.body.classList.add(webpSupport ? "hasWebp" : "noWebp");
  }
});
